module.exports = __webpack_public_path__ + "img/icon_attention.e5bdfe15.svg";